module.exports = __webpack_public_path__ + "static/img/verify-completed.4e40a2c0.png";